import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { useOccContext } from '../../../../context/occ/hooks/use-occ-context';
import { Icon } from '../../../icon';
import { Input } from '../input';
const b = bemClassBuilder('v-password-input');
export const PasswordInput = observer(props => {
    const { assets: occAssets, accessibilityText: occAccessibilityText } = useOccContext();
    const [passwordVisible, setPasswordVisible] = useState(false);
    const onVisibilityToggleClicked = () => setPasswordVisible(!passwordVisible);
    const { className } = props, otherInputProps = __rest(props, ["className"]);
    const visibilityButtonIconName = passwordVisible
        ? occAssets.passwordInputVisibleIconName
        : occAssets.passwordInputHiddenIconName;
    const visibilityButtonLabelName = passwordVisible
        ? occAccessibilityText.passwordInputHidePasswordButtonAriaLabel
        : occAccessibilityText.passwordInputShowPasswordButtonAriaLabel;
    return (_jsxs("div", Object.assign({ className: b.block(undefined, className) }, { children: [_jsx(Input, Object.assign({}, otherInputProps, { type: passwordVisible ? 'text' : 'password' })), _jsx("button", Object.assign({ className: b.element('visibility-button'), onClick: onVisibilityToggleClicked, "aria-label": visibilityButtonLabelName, tabIndex: -1, type: "button" }, { children: _jsx(Icon, { name: visibilityButtonIconName, className: b.element('icon') }) }))] })));
});
PasswordInput.displayName = 'PasswordInput';
